import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import ToastComponent from "../../components/ToastCompoent/ToastComponent";
import usePartnerName from "../../hooks/usePartnerName";
import { handleErrorMessage } from "../../utils/helper";

export default function useFilterData() {
  const partnerId = useSelector((state) => state?.localStorage?.partnerId);
  const { formattedName: partner } = usePartnerName();

  const [sectors, setSectors] = useState([]);
  const [subSectors, setSubSectors] = useState(null);
  const [organisationTypes, setOrganisationTypes] = useState([]);
  const [partnerDetails, setPartnerDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!partner) return;
    (async () => {
      try {
        const response = await getRequest(
          userapiservice.getPartnerDetails(partner)
        );
        if (response) setPartnerDetails(response);
      } catch (e) {
        console.error(e);
      }
    })();
  }, [partner]);

  useEffect(() => {
    if (!partnerId) return;
    (async () => {
      try {
        const [sectorsRes, orgTypesRes] = await Promise.all([
          getRequest(userapiservice.getAllSectors(partnerId)),
          getRequest(userapiservice.getOnOrganisationType(partnerId)),
        ]);
        if (sectorsRes) setSectors(sectorsRes);
        if (orgTypesRes) setOrganisationTypes(orgTypesRes);
      } catch (error) {
        toast.error(
          <ToastComponent
            type={"Error"}
            message={handleErrorMessage(error, "Failed to load filter data")}
          />
        );
      }
    })();
  }, [partnerId]);

  const fetchSubSectors = useCallback(async (sectorId) => {
    if (!sectorId) {
      setSubSectors(null);
      return;
    }
    setLoading(true);
    try {
      const response = await getRequest(
        userapiservice.getSubSectorsForFilter(sectorId)
      );
      setSubSectors(response);
    } catch (error) {
      toast.error(
        <ToastComponent
          type={"Error"}
          message={handleErrorMessage(error, "Failed to fetch sub-sectors")}
        />
      );
    } finally {
      setLoading(false);
    }
  }, []);

  const clearSubSectors = useCallback(() => {
    setSubSectors(null);
  }, []);

  return {
    sectors,
    subSectors,
    organisationTypes,
    partnerDetails,
    loading,
    fetchSubSectors,
    clearSubSectors,
  };
}
